import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function AdminGuard({ children }) {
    const [ok, setOk] = useState(null);
    const location = useLocation(); // window.location 대신 react-router의 location 사용 권장
    const isLoginPage = location.pathname === '/admin/login';

    useEffect(() => {
        // 1. 로그인 페이지면 그냥 '통과' 상태로 만들고 끝낸다.
        if (isLoginPage) {
            setOk(true);
            return;
        }

        const API = process.env.REACT_APP_API_BASE || 'http://localhost:8080';
        
        // 2. 요청 보내기 전 주소 깔끔하게 정리 (슬래시 중복 방지)
        const cleanAPI = API.endsWith('/') ? API.slice(0, -1) : API;

        fetch(`${cleanAPI}/api/auth/me`, { credentials: 'include' })
            .then(r => (r.ok ? r.json() : Promise.reject()))
            .then(() => setOk(true))
            .catch(() => {
                console.error("인증 실패");
                setOk(false);
            });
    }, [location.pathname, isLoginPage]);

    // 로딩 중일 때 화면이 깜빡이며 리다이렉트되는 걸 방지
    if (ok === null) return null;

    // 인증 실패 && 현재 로그인 페이지가 아닐 때만 리다이렉트
    if (!ok && !isLoginPage) {
        return <Navigate to="/admin/login" replace />;
    }

    return children;
}